import { render, staticRenderFns } from "./ApelacionElectronica.vue?vue&type=template&id=1769898e&"
import script from "./ApelacionElectronica.vue?vue&type=script&lang=js&"
export * from "./ApelacionElectronica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports